import React, { useState } from "react";
import PageTitle from "../../components/pageTitle/PageTitle";
import SingleSelect from "../../components/SelectField/SingleSelect";
import { Button, Container, Grid, TextField, Typography } from "@material-ui/core";
import { useMediaQuery } from "@mui/material";



const ContactUs = () => {
    const [formdata, setFormData] = useState({});
    const isMobile = useMediaQuery('(max-width:767px)');
    const isLandscape = useMediaQuery('(min-width: 771px) and (max-width: 940px)');

    const DepartmentOptions = [
        {label:"Sales", value:"sales"},
        {label:"General Inquiry", value:"generalInquiry"},
        {label:"Partnership", value:"partnership"}
    ]

    const handlefieldChange = (name, value) => {
        setFormData({ ...formdata, [name]: value });
    }

    const handleInputChange = (event) => {
        const {
            target: { name, value },
        } = event;
        setFormData({ ...formdata, [name]: value });
    };


    const onSaveChannel = () => {
        console.log("formData", formdata)
    };

    const clearformdata = () => {
        setFormData({});
    };


    return (
        <Container>
            <PageTitle
                pageTitle="Contact Us"
                showBreadcrumb={[
                    { label: "Home", to: "/" },
                    { label: "Support", to: "/help/support" },
                ]}
                BreadCrumbCurrentPageTitle={"Contact Us"}
                showLastSeen={true}
            />
            <div className="sectionBox">
                <Grid item sm={12} md={6} className="w-100">
                    <div className="mb-20 mt-10">
                        <Typography variant="body" style={{ fontSize: "16px", fontWeight: "500", color: "#3d3d3d" }}>Select Department</Typography>
                        <div className="mb-20 mt-10">
                            <SingleSelect
                                className={`field`}
                                label={"Select Department"}
                                name={"selectDepartment"}
                                InputLabelProps={{ shrink: true }}
                                value={formdata.selectDepartment}
                                onChange={(e) => handlefieldChange("selectDepartment", e.target.value)}
                                options={DepartmentOptions}
                            />
                        </div>
                        <Typography variant="body" style={{ fontSize: "16px", fontWeight: "500", color: "#3d3d3d" }}>Name</Typography>
                        <div className="mb-20 mt-10">
                            <TextField
                                label="Name"
                                value={formdata?.name}
                                fullWidth={true}
                                variant="outlined"
                                size="small"
                                className={`field`}
                                name={"name"}
                                onChange={handleInputChange}
                            />
                        </div>
                        <Typography variant="body" style={{ fontSize: "16px", fontWeight: "500", color: "#3d3d3d" }}>Email</Typography>
                        <div className="mb-20 mt-10">
                            <TextField
                                label="Email"
                                value={formdata?.email}
                                size="small"
                                fullWidth={true}
                                variant="outlined"
                                className={`field`}
                                name={"email"}
                                onChange={handleInputChange}
                            />
                        </div>
                        <Typography variant="body" style={{ fontSize: "16px", fontWeight: "500", color: "#3d3d3d" }}>Subject</Typography>
                        <div className="mb-20 mt-10">
                            <TextField
                                label="Subject"
                                value={formdata?.subject}
                                size="small"
                                fullWidth={true}
                                variant="outlined"
                                className={`field`}
                                name={"subject"}
                                onChange={handleInputChange}
                            />
                        </div>
                        <Typography variant="body" style={{ fontSize: "16px", fontWeight: "500", color: "#3d3d3d" }}>Description</Typography>
                        <div className="mb-20 mt-10">
                            <TextField
                                fullWidth={true}
                                name="description"
                                id="description"
                                multiline
                                rows={4}
                                variant="outlined"
                                value={formdata.description}
                                onChange={handleInputChange}
                                placeholder="Description"
                            />
                        </div>
                    </div>
                </Grid>
                <Grid container className="buttonwrap mt-30 mb-15">
                    <Grid item sm={12} md={12} className={isMobile || isLandscape ? "w-100" : ""}>
                        <Button
                            variant="contained"
                            color="primary"
                            style={{ borderRadius: "0px", boxShadow: "none" }}
                            className={isMobile || isLandscape ? "themebutton mr-12 ph-20 pv-8" : "themebutton flatbutton mr-12"}
                            onClick={onSaveChannel}
                        >
                            Save
                        </Button>
                        <Button
                            color="primary"
                            variant="contained"
                            style={{ borderRadius: "0px", boxShadow: "none" }}
                            className={isMobile || isLandscape ? "themebutton mr-12 ph-20 pv-8" : "themebutton flatbutton mr-12"}
                            onClick={clearformdata}
                        >
                            Cancel
                        </Button>
                    </Grid>
                </Grid>
            </div>
        </Container>
    )
}

export default ContactUs;